import intersectEffects from "./intersectEffects";

export default () => ({
    open: false, 
    toggleDD(event) {
      event.preventDefault();
      this.open = !this.open;
      // document.getElementById('swup').classList.toggle('dim');
      if(window.location.pathname == '/contact') {
        if(document.body.classList.contains('ddopen')) {
          document.body.classList.remove('ddopen');
          document.querySelector('.header').classList.add('dark');
        } else {
          document.body.classList.add('ddopen');
          document.querySelector('.header').classList.remove('dark');
        }  
      } else {
        if(document.body.classList.contains('ddopen')) {
          document.body.classList.remove('ddopen');
        } else {
          document.body.classList.add('ddopen');
        }
      }
    },
    closeDD(event) {
      event.preventDefault();
      this.open = false;
    },
    get isOpen() {
      return this.open ? 'true' : 'false';
    },
    get dropdownClass() {
      return this.open ? 'open' : '';
    },
    //     this.words = this.$el.dataset.words.split('|');
    //     this.cheight = this.$refs.pretitle.offsetHeight;
    //     this.cwidth = this.$refs.first.offsetWidth;
    //     this.speed = this.$el.dataset.speed;
    //     this.switcheroo()
    //     this.$watch('cheight', value => { this.updateStyles() })
    //     this.$watch('cwidth', value => { this.updateStyles() })
    // },
    // start() {
    //     this.updateStyles()
    //     setInterval(() => {
    //         this.$refs.first.classList.add('shift');
    //         this.$refs.second.classList.add('shift');
    //         this.cwidth = this.$refs.second.offsetWidth;
    //         this.switcheroo();
    //     }, this.speed);
    // },

    // switcheroo() {
    //     setTimeout(() => {
    //         this.$refs.first.classList.remove('shift')
    //         this.$refs.second.classList.remove('shift')
            
    //         this.$refs.first.innerText = this.words[this.index];
    //         if(this.index >= this.words.length - 1) {
    //             this.$refs.second.innerText = this.words[0];
    //         } else {
    //             this.$refs.second.innerText = this.words[this.index + 1];
    //         }
            
    //         // this.cwidth = this.$refs.second.offsetWidth;
            
    //         if(this.index >= this.words.length - 1) {
    //             this.index = 0;
    //         } else {
    //             this.index++;
    //         }
            
    //     }, 300);
    // },
    // updateStyles() {
    //     this.$refs.container.style.height = this.cheight + 'px'
    //     this.$refs.container.style.width = this.cwidth + 'px'
    // },
    // ... intersectEffects()
})